import { AxiosRequestConfig } from 'axios'

const tokenLogin = (): AxiosRequestConfig => ({
  url: `/auth/login/token`,
  method: 'POST',
})

export { tokenLogin }
